import {Component, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientContactQualification, CommonResponse, Constant, Contact, Designation, LeadDivision} from '../../../../../interfaces/home';
import {LeadService} from '../../../../../services/lead.service';
import {LeadDivisionContactService} from '../../../../../services/lead-division-contact.service';
import {ConfirmationService, MessageService} from 'primeng/api';
import {LeadDivisionService} from '../../../../../services/lead-division.service';
import { DesignationService } from 'src/app/services/designation.service';
import { ClientContactQualificationService } from 'src/app/services/client-contact-qualification.service';

@Component({
  selector: 'app-division-secondary-contact',
  templateUrl: './division-secondary-contact.component.html',
  styleUrls: ['./division-secondary-contact.component.scss'],
  providers: [Constant]
})
export class DivisionSecondaryContactComponent implements OnInit {
  @Input() suggestedSecondaryContact: Contact | null;
  divisionSecondaryContactForm: FormGroup;
  CurrentLeadDivisionData: LeadDivision = null;
  editingContact: boolean;
  titles : any[] = [];
  selectedTitle : any = null;
  genders : any[] = [];
  selectedGender : any = null;
  public yearRange: string;
  maxDateOfBirth: Date;
  designations: Designation[] = [];
  selectedDesignation: Designation = null;
  clientContactQualifications: ClientContactQualification[] = [];
  selectedClientContactQualification: ClientContactQualification = null;

  constructor(
      public leadService: LeadService,
      private formBuilder: FormBuilder,
      private leadDivisionContactService: LeadDivisionContactService,  
      private designationService: DesignationService,
      private clientContactQualificationService: ClientContactQualificationService,
      private messageService: MessageService,
      private confirmationService: ConfirmationService,
      private leadDivisionService: LeadDivisionService,
      private constants: Constant
  ) { }
  ngOnInit(): void {
    this.fetchDesignations();
    this.fetchContactQualifications();
    this.editingContact = false;
    this.titles = this.constants.titles;
    this.genders = this.constants.genders;

    this.maxDateOfBirth = new Date();
    const year = this.maxDateOfBirth.getFullYear() -18;
    this.maxDateOfBirth.setFullYear(year);
    this.yearRange = (year - 100) + ':' + year;
    
    this.divisionSecondaryContactForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobileNumber: ['', Validators.required],
      designation: [null, Validators.required],
      contactQualification: [null, Validators.required],
      dateOfBirth: [''],
      title: ['',  Validators.required],
      gender: ['',  Validators.required],
      type: 1,
      leadDivisionId: '',
    });
    this.divisionSecondaryContactForm.disable();
    this.leadDivisionService.activeLeadDivision().subscribe( async (res: any) => {
      this.divisionSecondaryContactForm.reset();
      this.CurrentLeadDivisionData = res;
      if(res !== null && res){
        await this.divisionSecondaryContactForm.enable();
        const _secondaryContact = res.secondaryContactId;
        if(_secondaryContact){
          await this.divisionSecondaryContactForm.disable();
          this.leadDivisionContactService.getLeadDivisionContact(_secondaryContact).subscribe( (r: CommonResponse) => {
            var result = r.responseData;
            this.divisionSecondaryContactForm.patchValue({
              firstName: result.firstName,
              lastName: result.lastName,
              email: result.email,
              mobileNumber: result.mobileNumber,
              dateOfBirth: result.dateOfBirth,
            });
            this.selectedTitle = this.titles.find(title => title.value.toLowerCase() === result.title.toLowerCase());
            this.selectedGender = this.genders.find(gender => gender.value.toLowerCase() === result.gender.toLowerCase());
            this.selectedDesignation = this.designations.find(x => x.id === result.designationId);
            this.selectedClientContactQualification = this.clientContactQualifications
                .find(x => x.id === result.clientContactQualificationId);
          })
        }
      }
    });
  }

  async fetchDesignations() {
    await this.designationService.allDesignationData().subscribe(async (res: any) => {
        this.designations = res;
    }, error => this.connectionError());  
  }

  async fetchContactQualifications() {
    await this.clientContactQualificationService.allClientContactQualificationData().subscribe(async (res: any) => {
        this.clientContactQualifications = res;
    }, error => this.connectionError());  
  }

  createContact() {
    this.messageService.add({severity:'info', summary: 'Notice',
      detail:'Processing Secondary Contact Creation'});
    this.divisionSecondaryContactForm.get('leadDivisionId').setValue(this.CurrentLeadDivisionData.id);
    this.divisionSecondaryContactForm.get('type').setValue(1);
    const postData= this.divisionSecondaryContactForm.value;
    postData.gender = this.divisionSecondaryContactForm.value.gender.value;
    postData.title = this.divisionSecondaryContactForm.value.title.value;
    postData.designationId = this.selectedDesignation.id;
    postData.clientContactQualificationId = this.selectedClientContactQualification.id;
    if(this.divisionSecondaryContactForm.valid) {
      this.leadDivisionContactService.postLeadDivisionContact(this.CurrentLeadDivisionData.id, postData).subscribe( async (res: any) => {
        await this.messageService.add({severity:'success', summary: 'Notice',
          detail:'Secondary contact Submitted'});
        await this.divisionSecondaryContactForm.reset();
        // redirect and set the current tab active
        await this.leadService.refreshData();
      } ) ;
    }
  }
  fillSuggestedContact() {
    if(!this.suggestedSecondaryContact){
      this.messageService.add({
        severity: 'error',
        detail: 'Resources not loaded',
        summary: 'Notice'
      })
      return;
    }
    this.divisionSecondaryContactForm.patchValue({
      firstName: this.suggestedSecondaryContact.firstName,
      lastName: this.suggestedSecondaryContact.lastName,
      email: this.suggestedSecondaryContact.email,
      mobileNumber: this.suggestedSecondaryContact.mobileNumber,
      designation: this.suggestedSecondaryContact.designation,
      dateOfBirth: this.suggestedSecondaryContact.dateOfBirth,
      type: 0,
    })
  }

  updateContact() {
    this.messageService.add({severity:'info', summary: 'Notice',
      detail:'Processing Secondary Contact Update'});
    this.divisionSecondaryContactForm.get('leadDivisionId').setValue(this.CurrentLeadDivisionData.id);
    this.divisionSecondaryContactForm.get('type').setValue(1);
    const postData= this.divisionSecondaryContactForm.value;
    postData.gender = this.divisionSecondaryContactForm.value.gender.value;
    postData.title = this.divisionSecondaryContactForm.value.title.value;
    postData.designationId = this.selectedDesignation.id;
    postData.clientContactQualificationId = this.selectedClientContactQualification.id;
    if(this.divisionSecondaryContactForm.valid) {
      this.leadDivisionContactService.updateLeadDivisionContact(this.CurrentLeadDivisionData.secondaryContact.id, postData).subscribe( async (res: any) => {
        await this.messageService.add({severity:'success', summary: 'Notice',
          detail:'Secondary contact Submitted'});
          this.cancelEditContact();
          this.leadService.refreshData();
      } ) ;
    }
  }

  cancelEditContact() {
    this.divisionSecondaryContactForm.disable();
    this.editingContact = false;
    const _secondaryContact = this.CurrentLeadDivisionData.secondaryContact;
    if(_secondaryContact){
      this.divisionSecondaryContactForm.disable();
      this.divisionSecondaryContactForm.patchValue({
        firstName: _secondaryContact.firstName,
        lastName: _secondaryContact.lastName,
        email: _secondaryContact.email,
        mobileNumber: _secondaryContact.mobileNumber,
        dateOfBirth: _secondaryContact.dateOfBirth,
        type: 1
      });
      this.selectedTitle = this.titles.find(title => title.value.toLowerCase() === _secondaryContact.title.toLowerCase());
      this.selectedGender = this.genders.find(gender => gender.value.toLowerCase() === _secondaryContact.gender.toLowerCase());
      this.selectedDesignation = this.designations.find(x => x.id === _secondaryContact.designationId);
      this.selectedClientContactQualification = this.clientContactQualifications
        .find(x => x.id === _secondaryContact.clientContactQualificationId);
    }
  }

  startEditing(){
    this.divisionSecondaryContactForm.enable();
    this.editingContact = true;
  }

  private connectionError() {
    this.messageService.add({
        severity: 'error', summary: 'Failed',
        detail: 'Connection Error, Please try again'
    });
  }
}
